module.exports = __webpack_public_path__ + "img/202502_05.c861eb7f.jpg";